import { z } from 'zod';
import { contactSharedSchema } from '../../common';

export const savedLocationContactSchema = contactSharedSchema.omit({
  personType: true,
});
export type SavedLocationContact = z.infer<typeof savedLocationContactSchema>;
